import "./styles.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { initMetrics } from "@smart/bridge-metrics-dom";
import { FragmentProvider } from "@smart/itops-hooks-dom";

import { Login } from "./components";
import { RouteSelector } from "./routes";

initMetrics();

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <StrictMode>
    <FragmentProvider>
      <Login>
        <RouteSelector />
      </Login>
    </FragmentProvider>
  </StrictMode>,
);
